
export enum  AreaStatus {
    Processing='Processing',
    Done='Done',
    Error='Error'
}

export enum  ImageStatus {
    Processing='Processing',
    Done='Done',
}

export type Area = { 
    name: String,
    status: AreaStatus,
    downloadUrl?: String,
    fileName: String,
    blueprintStatus?: ImageStatus,
    thumbnailStatus?: ImageStatus
}


// WEBPACK FOOTER //
// ./src/models/Area.ts